module.exports = __webpack_public_path__ + "log-in/img/background-3500px.a510477d.jpg";